
/*eslint-disable*/

// reactstrap components
import DashboardPro from "layouts/DashboardPro.js";
import { useEffect } from "react";
import { Container, Row, Col, Nav, NavItem, NavLink } from "reactstrap";

const Footer = () => {

  

  
  return (
    <footer class="footer pt-3  ">
    <div class="container-fluid">
      <div class="row align-items-center justify-content-lg-between">
        <div class="col-lg-6 mb-lg-0 mb-4">
          <div class="copyright text-center text-sm text-muted text-lg-start">
            © 2023, made with <i class="fa fa-heart"></i> by
            <a href="https://pollpe.in" class="font-weight-bold" target="_blank"> PollPe</a>
         
          </div>
        </div>
        <div class="col-lg-6">
          <ul class="nav nav-footer justify-content-center justify-content-lg-end">
          
            <li class="nav-item">
              <a href="https://www.pollpe.in/" class="nav-link text-muted" target="_blank">About Us</a>
            </li>
            <li class="nav-item">
              <a href="https://blog.pollpe.com" class="nav-link text-muted" target="_blank">Blog</a>
            </li>
          
          </ul>
        </div>
      </div>
    </div>
    <DashboardPro/>
  </footer>

  );
};

export default Footer;
